import {Component} from '@angular/core';
import {NgForm} from '@angular/forms';
import {RegisterCompanyStepBase} from '../register-company-step.base';

@Component({
    selector: 'app-register-company-account',
    templateUrl: './account-step.component.html',
    styleUrls: ['../../register-company.component.scss']
})
export class RegisterCompanyAccountStepComponent extends RegisterCompanyStepBase {

    showPassword = false;
    submitted = false;

    get passwordHasMinimumLength(): boolean {
        return (this.company.legalPassword?.length ?? 0) >= 8;
    }

    get passwordHasUpperAndLowerCase(): boolean {
        const password = this.company.legalPassword ?? '';
        return /[A-Z]/.test(password) && /[a-z]/.test(password);
    }

    get passwordHasNumber(): boolean {
        return /[0-9]/.test(this.company.legalPassword ?? '');
    }

    get passwordHasSpecialCharacter(): boolean {
        return /[\W_]/.test(this.company.legalPassword ?? '');
    }

    isPasswordValid(): boolean {
        return this.passwordHasMinimumLength
            && this.passwordHasUpperAndLowerCase
            && this.passwordHasNumber
            && this.passwordHasSpecialCharacter;
    }

    togglePasswordVisibility(): void {
        this.showPassword = !this.showPassword;
    }

    tryContinue(form: NgForm): void {
        this.submitted = true;
        form.form.markAllAsTouched();

        if (form.invalid || !this.isPasswordValid()) return;
        this.nextStep();
    }
}
